import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@deliveroo/consumer-component-library/components/Button';
import TextInput from '@deliveroo/consumer-component-library/components/TextInput';
import P from '@deliveroo/consumer-component-library/components/P';
import Modal from '@deliveroo/consumer-component-library/components/Modal';
import i18n from '../../utils/i18n';
import styles from './styles.scss';

export default class VoteAreaModal extends React.Component {
  state = {
    email: '',
  };

  emailInputChange = (event) => {
    const email = event.target.value;
    this.setState({ email });
  };

  submitForm = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.email);
  };

  render() {
    const {
      appElement,
      errorMessage,
      isSubmitted,
      heading,
      inputLabel,
      inputPlaceholder,
      ctaLabel,
      confirmationMessage,
      genericErrorMessage,
      isOpen,
      onClose,
    } = this.props;
    const { email } = this.state;

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        isOpen
        appElement={appElement}
        onClose={onClose}
        closeButtonLabel={i18n.gettext('closeButton.label')}
        type="fullscreen"
        headerTitle={heading}
      >
        <div className={classnames(styles.form, { [styles.submitted]: isSubmitted })}>
          <form onSubmit={this.submitForm}>
            <div className={styles.rider} />
            {!isSubmitted && (
              <Fragment>
                <TextInput
                  id="vote-area-email-input"
                  type="email"
                  name="email"
                  adjacentVerticalSpacing="medium"
                  value={email}
                  label={inputLabel}
                  placeholder={inputPlaceholder}
                  isInvalid={!!errorMessage}
                  errorMessage={errorMessage || genericErrorMessage}
                  onChange={this.emailInputChange}
                />
                <Button adjacentVerticalSpacing="medium" shouldSubmit isBlock>
                  {ctaLabel}
                </Button>
              </Fragment>
            )}
            {isSubmitted && (
              <P adjacentVerticalSpacing="medium">
                <span className={styles.confirmation}>{confirmationMessage}</span>
              </P>
            )}
          </form>
        </div>
      </Modal>
    );
  }
}

VoteAreaModal.propTypes = {
  appElement: PropTypes.string,
  isSubmitted: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  genericErrorMessage: PropTypes.string,
  heading: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  inputPlaceholder: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  confirmationMessage: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

VoteAreaModal.defaultProps = {
  appElement: '#__next',
  isSubmitted: false,
  errorMessage: undefined,
  genericErrorMessage: '',
};
